import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Btn, inputCls } from "@/components/admin/ui";

const PasswordForm = ({ user }) => {
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put(`/admin/users/${user.id}/password`, { password: pwd });
      toast.success(`Password updated for ${user.email}`);
      setPwd("");
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={save} className="flex flex-col gap-2 sm:flex-row" data-testid={`team-password-form-${user.email.split("@")[0]}`}>
      <input type="text" minLength={8} required value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="New password (8+ characters)" className={inputCls} data-testid={`team-password-input-${user.email.split("@")[0]}`} />
      <Btn variant="primary" type="submit" disabled={busy || pwd.length < 8} data-testid={`team-password-save-btn-${user.email.split("@")[0]}`}>Set password</Btn>
    </form>
  );
};

export const TeamCard = () => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/admin/users").then((r) => setUsers(Array.isArray(r.data) ? r.data : [])).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="rounded-2xl border border-[#2E2A24] bg-[#121215] p-5" data-testid="team-card">
      <p className="mb-4 font-mono-rc text-[11px] uppercase tracking-[0.2em] text-zinc-400">Team logins</p>
      <div className="divide-y divide-[#2E2A24]">
        {users.map((u) => (
          <div key={u.id} className="grid grid-cols-1 gap-3 py-3 sm:grid-cols-2 sm:items-center" data-testid={`team-user-${u.email.split("@")[0]}`}>
            <div>
              <p className="text-sm text-[#F5EFE6]">{u.email}</p>
              <p className="text-xs text-zinc-400">{u.role === "admin" ? "Admin · full access" : "Booking · inquiries and calendar only"}</p>
            </div>
            {u.email !== "admin@rhettco.org" && <PasswordForm user={u} />}
          </div>
        ))}
      </div>
    </div>
  );
};
